// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"971074d3","368":"25291b32","400":"6554ec49","453":"b51a737c","644":"7ea4c27e"}[chunkId] + ".chunk.js";
};